
import { VariavelEditavel } from '@/dominio/editor/questoes/comum/variavel/VariavelEditavel';
import { defineComponent } from 'vue';
import VariavelEdicao from './VariavelEdicao.vue';

export default defineComponent({
    name: 'AdicionarVariavel',
    components: {
        VariavelEdicao,
    },
    props: {
        indice: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            emEdicao: false,
        };
    },
    methods: {
        editar() {
            this.emEdicao = true;
        },
        adicionarItem(variavel: VariavelEditavel) {
            this.emEdicao = false;
            this.$emit('adicionarItem', variavel);
        },
        cancelou() {
            this.emEdicao = false;
        },
    },
    emits: ['adicionarItem'],
});
